// src/components/Popup.jsx
import React, { useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { ModalContext } from '../../../context/ModalContext';

// Styled Dialog with extra padding, rounded corners and shadow
const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[5],
  },
}));

const Popup = ({ children, sx }) => {
  const { setIdModal } = useContext(ModalContext);
  const handleClose = () => setIdModal('');

  return (
    <StyledDialog
      open={true}
      onClose={handleClose}
      PaperProps={{ sx }}
      aria-labelledby="popup-dialog-title"
    >
      <DialogTitle sx={{ m: 0, p: 1 }} id="popup-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </StyledDialog>
  );
};

export default Popup;